import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  counterpartyGetAvailableBranchesService,
  counterpartyGetBranchesService,
  getPermissionTableByBranchService,
} from '../services/branch.service';
import {
  TCounterpartyAvailableBranchesResData,
  TCounterpartyBranchesReqParams,
  TCounterpartyBranchesResData,
  TPermissionTableByBranchReqParams, TPermissionTableByBranchResData,
} from '../types/branch.types';

export const branchQueryKeys = createQueryKeys(EQueryKeys.BranchQueryKeys, {
  getBranches: (counterpartyGUID: string, params: TCounterpartyBranchesReqParams = {}) => ({
    queryKey: ['branches-list', params],
    queryFn: (): Promise<TCounterpartyBranchesResData> => counterpartyGetBranchesService(counterpartyGUID, params),
  }),
  getAvailableBranches: (counterpartyGUID: string, params?: TCounterpartyBranchesReqParams) => ({
    queryKey: ['available-branches-list', params],
    queryFn: (): Promise<TCounterpartyAvailableBranchesResData> =>
      counterpartyGetAvailableBranchesService(counterpartyGUID, params),
  }),
  getPermissionTableByBranch: (
    counterpartyGUID: string,
    branchGUID: string,
    params: TPermissionTableByBranchReqParams
  ) => ({
    queryKey: ['get-permission-table-by-branch-data', counterpartyGUID, branchGUID, params],
    queryFn: (): Promise<TPermissionTableByBranchResData> =>
      getPermissionTableByBranchService(counterpartyGUID, branchGUID, params),
  }),

  getBranches_MultiRole: (
    counterpartyGUID: string,
    params?: TCounterpartyBranchesReqParams,
    hasAccessForAllBranches?: boolean,
  ) => ({
    queryKey: ['branches-list-multi-role', counterpartyGUID, params, hasAccessForAllBranches],
    queryFn: (): Promise<TCounterpartyBranchesResData> | Promise<TCounterpartyAvailableBranchesResData> =>
      hasAccessForAllBranches
        ? counterpartyGetBranchesService(counterpartyGUID, params)
        : counterpartyGetAvailableBranchesService(counterpartyGUID, params),
  }),
});
